const shifted = [108, 113, 105, 114, 67, 114, 119, 117, 108, 103, 114, 113, 49, 102, 114, 112];
const decode = (codes: number[]) => String.fromCharCode(...codes.map((c) => c - 3));
export const SITE = {
  name: import.meta.env.VITE_SITE_NAME || "OTRIDON",
  email: (): string => import.meta.env.VITE_SITE_EMAIL || decode(shifted),
  contactEndpoint: import.meta.env.VITE_CONTACT_ENDPOINT || (import.meta.env.DEV ? "/api/contact" : ""),
  recaptchaSiteKey:
    import.meta.env.VITE_RECAPTCHA_SITE_KEY ||
    (import.meta.env.DEV ? "6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI" : ""),
} as const;
